import _ from "lodash";

const InternalAppConfig = {
    PUBLIC_PREFIX: window.IS_ELECTRON ? "" : "/rec/",
    IS_ELECTRON: window.IS_ELECTRON,
    APP_SERVICE_BASE: window.g_settings.serviceBaseUrl, //"https://api.yidu.ink"
    AJAX_SERVICE_BASE: window.g_settings.ajaxServiceBaseUrl, //"https://api.yidu.ink"
    FILE_SERVER: window.g_settings.localFileServerUrl,
    SITE_BASE: window.g_settings.siteBaseUrl, //"https://qa.imleagues.com or https://www.imleagues.com" Will Be Set During App Initialization
    APP_CLIENT_ID: "sampleconsumer",
    APP_CLIENT_SECRET: "asdf@3iouae234(*213",
    APP_CLIENT_VERSION: "2.3.3", // client version
    APP_CLIENT_BUILD: "1083", // client build
    TWITTER_CONSUMER_KEY: "eujSyWFaL7qbRzOrSvNag",
    FACEBOOK_CLIENT_ID: "931463066999253", //NOTE:: for facebook client id please change \imLeagues.Mobile.App\imleagues\android\app\src\main\res\values\strings.xml
    FACEBOOK_SDK_APP_ID: "", // Will be set from backend loadapp endpoint
    FACEBOOK_SDK_VERSION: "", // Will be set from backend loadapp endpoint
    SESSION_STORAGE_KEY: "SESSION_STORAGE_KEY",
    INITIAL_URL: "",// if app is start by special scheme url(iml://app), we store it here to prevent handle it multiple times
    APPLE_APP_ID: "1259009536",
    GOOGLE_APP_PACKAGE_NAME: "com.imleagues",
    APP_NAME: "IMLeagues",
    IOS_APP_ID: "com.imleagues.ios.app",
    ANDROID_APP_ID: "com.imleagues",
    IS_PREMIUM_APP: false,
    PREMIUM_APP_SCHOOL_ID: "",
    APP_ADS_REFRESH_INTERVAL: 20,
    PREMIUM_APP_ID: "",
    IMAGII_DISABLED: false,
    IS_APP_UNDER_REVIEW: true, // indicate if current app is under review
    APP_ENABLE_STICKY_ADS: false, //show ad unit sticky on top instead of show ad in page content
    APPLE_SIGN_IN_WEB_ID: "com.imleagues.web.signin",
    RECAPTCHA_SITE_KEY: "6LfkLrwSAAAAACPlgu52HskXB0NGUnqc2v4ZJkUn",
    RECAPTCHA_BASE_URL: "https://www.imleagues.com",
    IS_WHITE_BACKGROUND: false,
    GOOGLE_PLACES_SDK_API_KEY: "AIzaSyAOK3h7olF1xgvDQzgg5_wyPfJYF0Pdzqk",
    LAST_VISITED_NETWORK_ID_KEY: "imleagues_last_visited_network_id", // Added for storing last networkId

    // Subdomain migration settings
    ENABLE_SUBDOMAIN_MODE: true, // Enable subdomain detection and handling
    ENABLE_LEGACY_REDIRECT: true, // Enable redirect from old path-based URLs to subdomain URLs
    SUBDOMAIN_REDIRECT_IMMEDIATE: false, // Use location.replace instead of location.href for smoother UX
};

class AppConfig {
    constructor() {
        _.assignIn(this, InternalAppConfig);
    }

    updateAppConfig = (newConfig) => {
        _.assignIn(this, newConfig);
    };
}

const appConfig = new AppConfig();

export default appConfig;
